import { api } from "./apiSlice";
import { showMessage } from "../../helpers";

export const adminProductsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProductList: builder.query({
      query: (params = {}) => {
        // Set default values for required params
        const defaultParams = {
          limit: 10,
          offset: 0,
          recent: false,
          list: false
        };

        // Combine default params with provided params
        const queryParams = { ...defaultParams, ...params };

        // Convert params object to URL search params, filtering out undefined values
        const searchParams = new URLSearchParams();
        Object.entries(queryParams).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            searchParams.append(key, value);
          }
        });

        return `/admin/product/?${searchParams.toString()}`;
      },
      providesTags: ["AdminProducts"],
    }),

    getSingleProduct: builder.query({
      query: (id) => ({
        url: `/admin/product/${id}/`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'AdminProducts', id }],
    }),

    addProduct: builder.mutation({
      query: (data) => ({
        url: '/admin/product/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['AdminProducts'],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
          showMessage("success", "Product added successfully!");
        } catch (error) {
          showMessage("error", error.toString());
        }
      },
    }),

    editProduct: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/product/${id}/`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        'AdminProducts',
        { type: 'AdminProducts', id },
      ],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
          showMessage("success", "Product edited successfully!");
        } catch (error) {
          showMessage("error", error.toString());
        }
      },
    }),

    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `/admin/product/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AdminProducts'],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
          showMessage("success", "Product Deactivated!");
        } catch (error) {
          console.log(error);
        }
      },
    }),

    getProductDetails: builder.mutation({
      query: (data) => ({
        url: '/admin/product_detail/',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetProductListQuery,
  useGetSingleProductQuery,
  useAddProductMutation,
  useEditProductMutation,
  useDeleteProductMutation,
  useGetProductDetailsMutation,
} = adminProductsApi;
